<div class="session-container" [class.has-session]="!!recorderSession.sessionId">

  <div class="session-panel" [class.session-panel--boxed]="!!recorderSession.sessionId">

    <div class="session-panel-header" *ngIf="recorderSession.sessionId" (click)="toggleSessionDetails()">
      <span class="session-panel-title">Session Details</span>

      <!-- Quick access when collapsed — closing a session shouldn't require
           expanding this panel first just to reach the button. Sits right
           before the chevron, inside the same header line. -->
      <button
        class="btn-danger btn-quick-close"
        *ngIf="!sessionDetailsExpanded"
        (click)="$event.stopPropagation(); closeSession()"
        [disabled]="isClosingSession"
        [featureActionState]="'WEB_RECORDER'">
        <span *ngIf="!isClosingSession">Close Session</span>
        <span *ngIf="isClosingSession"><span class="spinner-sm"></span> Closing…</span>
      </button>

      <span class="material-symbols-outlined chevron" [class.chevron--collapsed]="!sessionDetailsExpanded">expand_more</span>
    </div>

    <div class="controls-row" *ngIf="!recorderSession.sessionId || sessionDetailsExpanded">

      <div class="control-group">
        <label>Lab</label>

        <span *ngIf="isLoadingLabs" class="lab-loading">
          <span class="spinner-sm"></span> Loading labs…
        </span>

        <span *ngIf="!isLoadingLabs && labLoadError" class="lab-error">
          {{ labLoadError }}
          <button class="btn-text" (click)="loadLabs()">Retry</button>
        </span>

        <select
          *ngIf="!isLoadingLabs && !labLoadError && labs.length > 0"
          [disabled]="!!recorderSession.sessionId"
          [value]="labs.indexOf(selectedLab)"
          (change)="selectLab(labs[$any($event.target).selectedIndex])"
          [featureActionState]="'WEB_RECORDER'">
          <option *ngFor="let lab of labs; let i = index" [value]="i">
            {{ lab.labHost }}
          </option>
        </select>

        <span *ngIf="!isLoadingLabs && !labLoadError && labs.length === 0" class="lab-empty">
          No labs assigned to your organisation.
        </span>
      </div>

      <div class="control-group" *ngIf="!recorderSession.sessionId">
        <label>Resolution</label>
        <select
          [(ngModel)]="selectedResolution"
          [featureActionState]="'WEB_RECORDER'">
          <option *ngFor="let res of resolutionOptions" [value]="res.value">
            {{ res.label }}{{ res.value === recommendedResolution ? ' (Recommended)' : '' }}
          </option>
        </select>
      </div>

      <div class="control-group url-group">
        <label>{{ recorderSession.sessionId ? 'Navigate' : 'URL' }}</label>
        <input
          type="url"
          [(ngModel)]="sessionUrl"
          [placeholder]="recorderSession.sessionId ? 'Enter URL to navigate…' : 'https://example.com'"
          (keyup.enter)="recorderSession.sessionId ? navigateSessionTo(false) : null"
          [featureActionState]="'WEB_RECORDER'" />
      </div>

      <div class="button-row">
        <button
          *ngIf="!recorderSession.sessionId"
          class="btn-primary btn-full"
          (click)="createSession()"
          [disabled]="isCreatingSession || !sessionUrl || !selectedLab || labs.length === 0"
          [featureActionState]="'WEB_RECORDER'">
          <span *ngIf="!isCreatingSession">Create Session</span>
          <span *ngIf="isCreatingSession">
            <span class="spinner-sm"></span> Creating…
          </span>
        </button>

        <button
          *ngIf="recorderSession.sessionId"
          class="btn-danger btn-full"
          (click)="closeSession()"
          [disabled]="isClosingSession"
          [featureActionState]="'WEB_RECORDER'">
          <span *ngIf="!isClosingSession">Close Session</span>
          <span *ngIf="isClosingSession">
            <span class="spinner-sm"></span> Closing…
          </span>
        </button>
      </div>

      <ng-container *ngIf="recorderSession.sessionId">

        <div class="button-row">
          <button class="btn-nav" (click)="navigateSessionTo(false)" [disabled]="!sessionUrl" [featureActionState]="'WEB_RECORDER'">
            <span class="material-symbols-outlined">open_in_browser</span>
            Same Tab
          </button>
          <button class="btn-nav" (click)="navigateSessionTo(true)" [disabled]="!sessionUrl" [featureActionState]="'WEB_RECORDER'">
            <span class="material-symbols-outlined">open_in_new</span>
            New Tab
          </button>
        </div>

        <div class="button-row">
          <input type="file" id="fileUpload" #fileInput (change)="onFileSelected($event)" style="display:none" />
          <button class="btn-file btn-full" (click)="fileInput.click()" [featureActionState]="'WEB_RECORDER'">
            <span class="material-symbols-outlined">attach_file</span>
            {{ selectedFile ? selectedFile.name : 'Choose File' }}
          </button>
        </div>

        <div class="button-row" *ngIf="selectedFile">
          <button class="btn-upload btn-full" (click)="uploadFileToSession()" [disabled]="isUploading" [featureActionState]="'WEB_RECORDER'">
            <span class="material-symbols-outlined">upload</span>
            {{ isUploading ? 'Uploading…' : 'Send' }}
          </button>
        </div>

      </ng-container>

    </div>

  </div>

  <div class="toolbar-slot" (click)="collapseSessionDetails()">
    <ng-content select="[recorder-toolbar]"></ng-content>
  </div>

  <div class="sidebar-slot" (click)="collapseSessionDetails()">
    <ng-content select="[recorder-sidebar]"></ng-content>
  </div>

  <div class="vnc-wrapper" *ngIf="recorderSession.sessionId">
    <div id="vnc-screen" class="vnc-frame" [featureActionState]="'WEB_RECORDER'"></div>
  </div>

</div>